module.exports = __webpack_public_path__ + "static/media/back13.85f694d7.jpg";